import { JSX } from 'react';
import {
  GSKInstance,
  HexalInstance,
  IncyteInstance,
  NovartisInstance,
  SeqirusInstance,
} from '@common/enums';
import { Button } from '@components/ui/button';
import useChat from '@hooks/use-chat';
import { cn, CURRENT_INSTANCE, shouldUseSessionStorage } from '@lib/utils';
import { useTranslation } from 'react-i18next';
import GSKAgreementBanner from './gsk-agreement-banner';
import HexalAgreementBanner from './hexal-agreement-banner';
import IncyteAgreementBanner from './incyte-agreement-banner';
import IncyteDermaAgreementBanner from './incyte-derma-agreement-banner';
import IncyteOnkoAgreementBanner from './incyte-onko-agreement-banner';
import NovartisAgreementBanner from './novartis-agreement-banner';
import SeqirusAgreementBanner from './seqirus-agreement-banner';

function MainAgreementBanner() {
  const { setShowAgreementBanner, setAgreedToDisclaimer, setAgreedToDisclaimerPerSession } =
    useChat();
  const { t } = useTranslation();

  function handleAgree() {
    if (shouldUseSessionStorage()) setAgreedToDisclaimerPerSession(true);
    else setAgreedToDisclaimer(true);
    setShowAgreementBanner(false);
  }
  function handleDisagree() {
    setShowAgreementBanner(false);
  }

  const agreementBanners: Record<string, JSX.Element> = {
    [IncyteInstance.Default]: <IncyteAgreementBanner />,
    [IncyteInstance.Derma]: <IncyteDermaAgreementBanner />,
    [IncyteInstance.Onko]: <IncyteOnkoAgreementBanner />,
    [HexalInstance.Default]: <HexalAgreementBanner />,
    [NovartisInstance.Default]: <NovartisAgreementBanner />,
    [GSKInstance.Default]: <GSKAgreementBanner />,
    [SeqirusInstance.Default]: <SeqirusAgreementBanner />,
  };

  // Use a custom bg for Hexal
  let bgColor: string = 'bg-xircle-main';
  if (CURRENT_INSTANCE.name === HexalInstance.Default) bgColor = 'bg-[#9898A2]';

  return (
    <div className="absolute inset-0 w-full h-full z-10 bg-white">
      <div className={`w-4/5 rounded-lg p-4 mx-auto mt-2 ${bgColor} z-10`}>
        {agreementBanners[CURRENT_INSTANCE.name]}
        <div className="w-full flex flex-col sm:flex-row justify-center items-center gap-3 mt-6">
          <Button
            className={cn(
              'bg-xircle-secondary border-none text-lg uppercase shadow-md',
              CURRENT_INSTANCE.name === HexalInstance.Default &&
                'text-hexal-dark-text-color hover:text-slate-200'
            )}
            size="lg"
            onClick={handleAgree}
          >
            {t('agreement_banner.agree_button')}
          </Button>
          <Button
            className={cn(
              'bg-xircle-secondary border-none text-lg uppercase shadow-md',
              CURRENT_INSTANCE.name === HexalInstance.Default &&
                'text-hexal-dark-text-color hover:text-slate-200'
            )}
            size="lg"
            onClick={handleDisagree}
          >
            {t('agreement_banner.disagree_button')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default MainAgreementBanner;
